import { render, staticRenderFns } from "./templateContent.vue?vue&type=template&id=46f8ea9c&scoped=true&"
import script from "./templateContent.vue?vue&type=script&lang=js&"
export * from "./templateContent.vue?vue&type=script&lang=js&"
import style0 from "./templateContent.vue?vue&type=style&index=0&id=46f8ea9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f8ea9c",
  null
  
)

export default component.exports